import React from 'react';

import styles from './styles/dropdown.module.css';

import {ReactComponent as ArrowDown} from '../../assets/chat/arrow-down.svg';
import {ReactComponent as ArrowUp} from '../../assets/chat/arrow-up.svg';

export default function Dropdown({ isOpenDropdown, toggleDropdown }) {
    return (
        <div className={styles.wrapper} onClick={toggleDropdown}>
            {isOpenDropdown 
                ? <ArrowUp />
                : <ArrowDown />
            }
        </div>
    );
}
